export default __webpack_public_path__ + "static/media/H1007.2.4121c5b3.mp3";